import { Component, DOCUMENT, Inject, Input, SimpleChanges } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { MeetList } from '@athleticnet/athletic-live-api-models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { combineLatest, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DataContext } from '../../my-meet/models/data-context.model';
import { AuthService } from '../anet/auth/auth.service';
import { AthleticFollowInfo } from '../anet/models/athletic-follow-info.interface';
import { AthleticUser } from '../anet/models/athletic-user.interface';
import { AnetLiveService } from '../anet/services/anet-live.service';
import { FollowModalDataModel } from '../models/follow-modal-data.model';
import { CurrentMeetService } from '../services/current-meet.service';
import { ModalService } from '../services/modal.service';

@Component({
  selector: 'app-follow-button',
  imports: [FontAwesomeModule],
  templateUrl: './follow-button.component.html',
  styleUrls: ['./follow-button.component.scss'],
})
export class FollowButtonComponent {
  @Input() dataContext!: DataContext;
  @Input() showFollowText: boolean = false;

  isFollowing: boolean = false;
  isLoggedIn: boolean = false;
  redirUrl!: string;
  meetUserContextSub!: Subscription;
  meet!: MeetList | null;
  user!: AthleticUser | null;
  anetFollowInfo!: AthleticFollowInfo | null;

  constructor(
    protected currentMeetService: CurrentMeetService,
    protected anetLiveService: AnetLiveService,
    protected authService: AuthService,
    protected router: Router,
    protected modalService: ModalService,
    protected route: ActivatedRoute,
    @Inject(DOCUMENT) private document: any,
  ) {
    this.redirUrl = this.document.location.origin + this.router.url;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataContext'] && !changes['dataContext'].isFirstChange() && this.user) {
      this.applyFollowing();
    }
  }

  ngOnInit() {
    this.meetUserContextSub = combineLatest([
      this.currentMeetService.updateMeet,
      this.authService.updateUser,
      this.authService.updateFollowInfo,
    ]).subscribe(
      async ([meet, user, followInfo]: [MeetList | null, AthleticUser | null, AthleticFollowInfo | null]) => {
        this.meet = meet;
        this.user = user;
        this.anetFollowInfo = followInfo;
        if (user && user?.userId > 0) {
          this.user = user;
          this.isLoggedIn = true;
        }
        this.applyFollowing();

        // TODO: Get list of existing
      },
    );
  }

  applyFollowing() {
    const followNotifyStatus = this.dataContext.getFollowNotifyStatus(this.anetFollowInfo, this.isLoggedIn);
    this.isFollowing = followNotifyStatus.isFollowing;
  }

  async openModal() {
    await this.modalService.openFollowModal(new FollowModalDataModel(this.dataContext), this.route);
  }

  ngOnDestroy() {
    if (this.meetUserContextSub) {
      this.meetUserContextSub.unsubscribe();
    }
  }

  protected readonly environment = environment;
}
